import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { AuthGuard } from '../../components/AuthGuard';
import DriverOpsLayout from './layouts/DriverOpsLayout';
import DriverActivityListPage from './activity/DriverActivityListPage';
import DriverActivityFormPage from './activity/DriverActivityFormPage';
import DriverActivityDetailPage from './activity/DriverActivityDetailPage';

const DriverOpsRoutes: React.FC = () => {
    return (
        <Routes>
            <Route path="/" element={<AuthGuard><DriverOpsLayout /></AuthGuard>}>
                <Route path="activity" element={<DriverActivityListPage />} />
                <Route path="activity/new" element={<DriverActivityFormPage />} />
                <Route path="activity/:id/edit" element={<DriverActivityFormPage />} />
                <Route path="activity/:id" element={<DriverActivityDetailPage />} />
            </Route>
        </Routes>
    );
};

export default DriverOpsRoutes;
